<ng-container *ngFor="let i of rows; index as ii">
    <div class="row">
        <div
            [ngClass]="'col-' + 12 / vil.layout.itemsPerRow"
            *ngFor="let j of i"
        >
            <ng-container
                *ngTemplateOutlet="
                    ii % 2 === 0 ? nameTpl : chartTpl;
                    context: { j: j }
                "
            ></ng-container>
        </div>
    </div>
</ng-container>

<ng-template
    #nameTpl
    let-j="j"
>
    <div
        class="text-center"
        data-metric
    >
        {{ j.metric?.shortName }}
    </div>
</ng-template>

<ng-template
    #chartTpl
    let-j="j"
>
    <div
        class="insight-chart"
        [id]="j.id"
        role="button"
        data-chart
        (click)="onChartClick($event, j)"
        (mouseenter)="onChartMouseEnter($event, j)"
        (mouseleave)="onChartMouseLeave($event, j)"
    >
        <ng-chart-arc
            [options]="j.peerGroup.chartOpts"
            [data]="j.peerGroup.chartData"
            *ngIf="peerGroupData"
        ></ng-chart-arc>
        <div [ngClass]="{ 'insight-chart-inside': peerGroupData }">
            <ng-chart-arc
                [options]="j.chartOpts"
                [data]="j.chartData"
            ></ng-chart-arc>
        </div>
    </div>
</ng-template>
